import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DrillsService } from '@drills/infra';
import { SessionRouting } from './session.routes';

@NgModule({
  imports: [RouterModule.forChild(SessionRouting)],
  providers: [DrillsService]
})
export class SessionModule {}
